export default __webpack_public_path__ + "static/media/globe.738e4870.svg";